<div class="astral-stack-l">
  <h5>{{ 'COMPANY.SETTINGS_RAINDANCE' | translate }}</h5>
  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
    <astral-input [control]="form.controls['fileExtension']"></astral-input>
    <astral-select [control]="form.controls['encodingName']" [itemsSource]="encodingSelection"></astral-select>
    <astral-checkbox [control]="form.controls['bundleFile']"></astral-checkbox>
    <astral-checkbox [control]="form.controls['asymmetricBundling']"></astral-checkbox>
    <astral-checkbox [control]="form.controls['includeTodaysWork']"></astral-checkbox>
    @for (field of [
      ['ansv', 'ansvFixed'],
      ['vht', 'vhtFixed'],
      ['akt', 'aktFixed'],
      ['obj', 'objFixed'],
      ['proj', 'projFixed'],
      ['mk', 'mkFixed'],
      ['fri', 'friFixed'],
      ['motp', 'motpFixed'],
      ['periodisering', 'periodiseringFixed']
      ]; track field) {
      <astral-select [control]="form.controls[field[0]]" [itemsSource]="dimensionSelection"></astral-select>
      @if (form.controls[field[0]].value == 99) {
        <astral-input [control]="form.controls[field[1]]"></astral-input>
      }
    }
  </astral-layout-group>
</div>
